/**
 * TUIChatKit 延迟初始化：避免首屏加载 chat-uikit-engine / server 等大包。
 * 在首次 IM 登录或打开消息中心前调用 ensureTUIKitReady()，保证聊天组件挂载前已 init。
 */
let readyPromise = null
let tuiChatKitInstance = null

export function ensureTUIKitReady() {
  if (readyPromise) return readyPromise
  readyPromise = (async () => {
    const [{ default: Server }, { TUITranslateService }] = await Promise.all([
      import(/* webpackChunkName: "tUIKit-server" */ '@/TUIKit/server'),
      import('@tencentcloud/chat-uikit-engine-lite')
    ])
    tuiChatKitInstance = new Server()
    tuiChatKitInstance.init()
    if (TUITranslateService && typeof TUITranslateService.changeLanguage === 'function') {
      TUITranslateService.changeLanguage('zh')
    }
    return tuiChatKitInstance
  })()
  return readyPromise
}

/** 供少数需在 init 后同步取实例的场景（一般不必用） */
export function getTUIChatKit() {
  return tuiChatKitInstance
}
